import axiosInstance from './Instance/axiosInstance';
import { SupplierPayment } from '../types/supplierPayment';

export const getSupplierPayments = async (): Promise<SupplierPayment[]> => {
    const res = await axiosInstance.get('/supplier-payments');
    return res.data;
};

export const createSupplierPayment = async (data: Omit<SupplierPayment, 'id'>): Promise<SupplierPayment> => {
    const res = await axiosInstance.post('/supplier-payments', data);
    return res.data;
};

export const updateSupplierPayment = async (id: string, data: Omit<SupplierPayment, 'id'>): Promise<SupplierPayment> => {
    const res = await axiosInstance.put(`/supplier-payments/${id}`, data);
    return res.data;
};

export const deleteSupplierPayment = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/supplier-payments/${id}`);
};
